import { API_DOMAIN } from '@constants';
import axios from '@utils/axios';
import { subtitleFormat } from '@utils/subtitleFormat';

interface TextToVoiceParams {
  text: string;
  declaimer: string;
  speed?: number;
  volume?: number;
  sampleRate?: number;
  format?: 'pcm' | 'wav' | 'mp3';
}

/** 文本转语音 */
export const textToVoice = async ({
  text,
  declaimer,
  speed = 0,
  volume = 50,
  sampleRate = 16000,
  format = 'mp3',
}: TextToVoiceParams): Promise<{ url: string; subtitle?: string }> => {
  // 步骤一,请求接口进行文本转语音
  const { taskId, requestId } = await axios.post<{
    taskId: string;
    requestId: string;
  }>(`${API_DOMAIN}/member/my/tts/upload`, {
    text,
    declaimer,
    speed,
    volume,
    sampleRate,
    format,
  });
  // 步骤二,每隔2秒轮询服务器查询任务是否完成
  while (true) {
    await new Promise((resolve) => {
      setTimeout(() => resolve(0), 2000);
    });
    const result = await axios
      .post<any>(`${API_DOMAIN}/member/my/tts/download`, { taskId, requestId })
      .catch(() => {
        return {};
      });
    // 完成则返回转换后的音频URL
    if (result.url) {
      return {
        url: result.url.replace('http://', 'https://'),
        subtitle: subtitleFormat(result.subtitle) ?? '',
      };
    }
  }
};
